import { computed, inject, Injectable, signal } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { HouseholdService } from '@services/household.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class EnsureHouseholdIsNotProcessing implements CanActivate {
  private householdService = inject(HouseholdService);
  private translateService = inject(TranslateService);
  private toastService = inject(ToastrService);
  private router = inject(Router);
  private route = signal<ActivatedRouteSnapshot | null>(null);

  private householdId = computed(() => {
    const id = this.route()?.paramMap.get('id');
    return id ? Number(id) : null;
  });

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): MaybeAsync<GuardResult> {
    this.route.set(route);

    if (!this.householdId()) {
      return this.router.createUrlTree(['/foyers']);
    }

    return this.householdService.getHousehold(this.householdId()!).pipe(
      map(h => {
        if (h.is_processing) {
          this.toastService.error(
            this.translateService.instant('errors.household_processing')
          );
          return this.router.createUrlTree(['/foyers']);
        }
        return true;
      }),
      // tap() plus nécessaire pour le toast
      catchError(() => of(this.router.createUrlTree(['/foyers'])))
    ) as Observable<GuardResult>;
  }
}
